export const actionSheetItems = [
    { text: 'Call' },
    { text: 'Detail' },
    { text: 'Edit' },
    { text: 'Delete' },
  ];
